export default __webpack_public_path__ + "static/media/slidenote1.259c0596.png";